export default __webpack_public_path__ + "static/media/prev.372a3978.svg";